import { createAsyncThunk } from '@reduxjs/toolkit';
import api, { SendDisputeRequest } from './api';
import { NAME } from './constants';

export const getDisputeCategories = createAsyncThunk(`${NAME}/getCategories`, async () => {
  try {
    return await api.getCategories();
  } catch (error) {
    console.error(`${NAME}/getCategories`, error);
    throw new Error('Error fetching dispute categories');
  }
});

export const sendDispute = createAsyncThunk(
  `${NAME}/sendDispute`,
  async (request: SendDisputeRequest) => {
    try {
      return await api.sendDispute(request);
    } catch (error: any) {
      console.error(`${NAME}/sendDispute`, error);
      const errorMessage = error?.response?.data?.error || 'Error submitting dispute';
      throw new Error(errorMessage);
    }
  }
);
